import { getDataMapper, mapField } from "@/shared";

export const mapFDocDocumentToServer = getDataMapper({
    order_id: mapField("orderId", Number),
    type: mapField("type", String),
    object_id: mapField("objectId", Number),
});
